<template>
  <div class="bg-golf spbox pginner">
    <section id="blk-ec" class="tabtgtbox">
      <h2 class="tac nmg">通販</h2>
      <div class="skubox pdvboxL">
        <ul>
          <li class="skutbl" v-for="ec in eclist">
            <div class="tblcl">
              <span class="skusite">
                <span v-if="ec.ec_store.official == 1" class="lbl lbl-official">公式サイト</span><br>{{ec.ec_store.name}}
              </span>
            </div>
            <div class="tblcl tac">
              <span class="skuprc fwb fcr">¥{{ec.price | addComma}}</span>
              <span class="skushp">送料: {{ec.shippingfee}}</span>
            </div>
            <div class="tblcl tac">
              <div class="skucart" v-html="ec.link">
              </div>
            </div>
          </li>
        </ul>
        <p class="itmcaut">
        ※税込み、送料を含まない価格で比較しています。<br>
        ※在庫・価格の情報は、メーカー品番・中身から類推して比較しています。各サイトの商品が同一商品であることを保証するものではありませんので、ご了承ください。
        </p>
      </div>
    </section>
  </div>
</template>


<script>
export default {
  props: ['eclist'],
}
</script>

<style>

/*eclisdl*/
.skubox{width: 100%; max-width: 500px; margin: 0 auto;}
.skutbl{display: table; table-layout: fixed; width: 100%; font-size: 1.2em; background-color: #FFF; border-radius: 6px; margin-bottom: 4px; padding: 8px; }
.skutbl .tblcl{padding: 10px 0 10px 8px;}
.skutbl td:first-child{padding: 6px 0;}

.skusite{word-break: break-all; font-size: .95em;}
.skucart a{font-weight: bold; width: 100%; padding: 4px; display: block; background-color: #F98866; color: #FFF; text-decoration: none; box-sizing: border-box; border-radius: 2px; line-height: 20px;}
.skuprc{font-size: 1.05em; font-weight: normal; display: block;}
.skuprcmin{font-size: 1.15em; font-weight: bold; display: block;}
.skushp{font-size: .85em; font-weight: normal; display: block; color: #AAA; padding-top: 4px;}
.skuout a{background-color: #b7b8b6;}
.cartpre a{background-color: #4cb5f5;}
.itmcaut{color: #333; font-size: .85em; line-height: 1.2em; padding: 8px 0; margin: 0;}
.itmcaut{color: #333; font-size: .85em; line-height: 1.2em; padding: 8px 0; margin: 0; text-align: left;}
</style>
